export default __webpack_public_path__ + "static/signing-b9e77830e09e800a861537929c8a0f9a.webp";